module.exports = __webpack_public_path__ + "img/store_template_poup.6ff769b8.png";